<template>

    <div class="w-96  shadow-lg  m-9 p-6 bg-gray-50 h-auto">
        <div class=" text-xl base_color">修改登录密码</div>
        <div class="">

             <div class="mt-6 ">
             <p class=" text-base text-gray-500">原密码</p>
            <input  type="password" placeholder="请输入原密码"  class="focus:outline-none border h-12 pl-3 w-full inputEle rounded mt-2" maxlength="10" v-model.lazy.trim="oldPwd" @keyup.enter="gotoNext(1)"/>
                </div>

                 <div class="mt-6">
                     <p  class=" text-base text-gray-500">新密码</p>
            <input  type="password" placeholder="请输入"  class="focus:outline-none  border h-12 pl-3 w-full inputEle rounded  mt-2" maxlength="10" v-model.lazy.trim="newPwd" @keyup.enter="gotoNext(2)"/>
                </div>

               <div class="mt-6">
                    <p  class=" text-base text-gray-500">再次确认</p>
            <input  type="password" placeholder="请再次输入新密码"  class="focus:outline-none border h-12 pl-3 w-full inputEle rounded mt-2" maxlength="10" v-model.lazy.trim="newPwdConfirm" @keyup.enter="gotoNext(3)"/>
                </div>

                <div class="mt-10">
                        <button  class="bg-green-500 active:bg-green-700 h-12 w-full rounded text-white inputEle" @click="doSave">保&nbsp;&nbsp;存</button>
                </div>
        </div>
    </div>

</template>
<script>
import { ref } from '@vue/reactivity';
import { ElNotification, ElLoading, ElMessageBox,ElMessage } from 'element-plus';
import axios from '@/utils/axios';
export default {
  setup () {
    const newPwd = ref('')
    const newPwdConfirm = ref('')
    const oldPwd = ref('')
    const gotoNext = (idx) => {
      document.getElementsByClassName('inputEle')[idx].focus()
    }
    const doSave = () => {
      if(newPwd.value!=newPwdConfirm.value){
        ElNotification({
          title: '错误',
          message: '两次输入的新密码不一致',
          type: 'error',
          position: 'top-left'
        })
        return;
      }

      ElMessageBox.confirm('是否确定修改登录密码?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      axios.post('/pos_cashier/pwd', {
        old_pwd: oldPwd.value,
        new_pwd: newPwd.value
      }).then(res => {
        ElMessage({
          showClose: true,
          message: '修改成功',
          type: 'success'
        });
        oldPwd.value="";
        newPwd.value="";
        newPwdConfirm.value="";

      })
        .finally(() => {
          loading.close()
        })

          })
    }
    return {
      newPwd, newPwdConfirm, oldPwd, gotoNext, doSave
    }
  }
}
</script>
<style scoped>

</style>
